<template>
  <!----echarts-药品生产入库详情--->
  <div class="container">
    <crumb prevLevel="生产数据监管/药品生产入库" current="药品生产入库" />
    <div class="search">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="药品通用名称">
              <el-input
                v-model="Params.drugName"
                placeholder="请输入药品通用名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品批准文号">
              <el-input
                v-model="Params.appNo"
                placeholder="请输入药品批准文号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产日期">
              <el-date-picker
                v-model="Params.productDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品性质">
              <el-select v-model="Params.productType">
                <el-option label="全部" value="" />
                <el-option label="中成药" value="中成药" />
                <el-option label="化学药品" value="化学药品" />
                <el-option label="生物制品" value="生物制品" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药品分类">
              <el-select v-model="Params.isSpecial">
                <el-option label="全部" value="" />
                <el-option label="特药" value="1" />
                <el-option label="其它" value="0" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否OTC">
              <el-select v-model="Params.isPrescribed">
                <el-option label="全部" value="" />
                <el-option label="处方药" value="处方药" />
                <el-option label="非处方药" value="非处方药" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label-width="0">
              <el-button type="primary" style="margin-left:30px" @click="init()"
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="tip">
      *
      使用药品性质、药品分类、是否OTC查询条件时，关联数据量大，需要时间较长，请耐心等待
    </div>
    <div class="statistic">
      <div class="title">药品生产入库数量统计</div>
      <div class="content">
        <div class="num-list">
          <div class="num-item">
            <div class="num">{{ licenseNoNum }}</div>
            <div class="text">药品批准文号数量</div>
          </div>
          <div class="num-item">
            <div class="num">{{ drugRkNum }}</div>
            <div class="text">药品生产入库数量(最小包装单位)</div>
          </div>
        </div>
        <Echarts :echartsOption="echartsOption" />
      </div>
    </div>
    <div class="table-list">
      <div class="title">药品生产列表</div>
      <el-table :data="supplierList" class="table">
        <el-table-column prop="ent_name" label="生产企业名称" />
        <el-table-column prop="product_name" label="药品通用名称" />
        <el-table-column prop="approval_number" label="药品批准文号" />
        <el-table-column prop="dosage_form" label="剂型" />
        <el-table-column prop="drug_specifications" label="规格" />
        <el-table-column prop="batch_number" label="生产批号" />
        <el-table-column prop="issuance_date" label="入库日期" />
        <el-table-column prop="validity_time" label="有效期" />
        <el-table-column prop="num" label="生产数量" />
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';
import Crumb from 'components/crumb/crumb';
import paginationMixin from './pagination.mixin';

export default {
  data() {
    return {
      licenseNoNum: '',
      drugRkNum: '',
      Params: {
        drugName: '',
        appNo: '',
        productDate: '',
        productType: '',
        isSpecial: '',
        isPrescribed: '',
        taxno: '',
        organId: ''
      },
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
              textStyle: {
                color: '#666'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#999'
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239,0.5)'
              }
            }
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: '27px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#5140C6' },
                { offset: 0, color: '#386CE2' }
              ])
            },
            data: []
          }
        ]
      },
      supplierList: []
    };
  },
  mixins: [paginationMixin],
  components: {
    Echarts,
    Crumb
  },
  mounted() {
    this.Params.taxno = this.$route.query.data.name;
    this.Params.organId = this.$route.query.data.id;
    this.init();
  },
  methods: {
    init() {
      this.queryParams();
      this.EchartsData();
    },
    // 列表
    queryParams() {
      this.$request({
        url: 'open/production/drugList',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: this.currentPage, pageSize: this.pageSize },
            params: {
              ...this.Params
            }
          })
        }
      }).then(res => {
        this.supplierList = res.list ? [...res.list] : [];
        this.total = res ? res.total : 0;
      });
    },
    // ecarts 柱状图
    EchartsData() {
      const xData = [];
      const yData = [];
      this.$request({
        url: 'open/production/drugRkStatics',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: 1, pageSize: 1000 },
            params: {
              ...this.Params
            }
          })
        }
      }).then(res => {
        this.drugRkNum = res.drugRkNum;
        this.licenseNoNum = res.licenseNoNum;
        res.list.forEach(item => {
          xData.push(item.product_name);
          yData.push(item.num);
        });
        this.echartsOption.xAxis[0].data = xData;
        this.echartsOption.series[0].data = yData;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.tip
  color #999
  font-size 12px
  margin -20px 0 30px 43px
.container
  width 1352px
  background #fff
  border-radius 4px
  margin-left -46px
  color #000
  padding 0 20px
  .search
    padding 30px 0
  .statistic, .table-list
    .title
      font-size 14px
      color #242424
      line-height 40px
      border-bottom 1px solid rgba(206,219,239,0.5)
      padding-left 44px
      font-weight 700
    .content
      .num-list
        padding 20px 0
        display flex
        justify-content center
        .num-item
          text-align center
          margin 0 50px
          .num
            color #386CE2
            font-size 28px
            margin-bottom 5px
            font-weight 500
          .text
            font-size 12px
  .table-list
    overflow hidden
    .table
      margin-top 20px
      >>>.el-table__body-wrapper
          .cell
            padding 12px 0
    .pagination
      float right
      padding-top 30px
      padding-bottom 50px
</style>
